var Entities = require('Entities');
var Lookups = EY.Consultation.Lookups;
var StatusType = EY.Consultation.Lookups.StatusType;

module.exports.run = function (options) {
    var record = options.record;

    if (record.get('recordTypeId') === Lookups.RecordType.RequiredNotification && record.get('statusTypeId') === StatusType.UsersNotified) {
        var approverList = new Entities.Approvers(options.approvers.reject({ upn: '' }));
        var approvers = new Entities.Approvers(approverList.reject({ approvalNotRequired: false }));

        approvers.find({ upn: EY.Consultation.CurrentUser.upn }).set({ acknowledgeDate: new Date(), acknowledgeStatus: true });
        if (approvers.filter({ acknowledgeDate: '', acknowledgeStatus: '' }).length === 0) {
            options.activities.reset();
            options.approvers.each(function (approver) { approver.set({ acknowledgeDate: '', acknowledgeStatus: '' }); }); //AM Fix for "Pending My Action" filter
            record.set({
                statusTypeId: StatusType.Complete,
                completedOn: new Date(),
                statusResourceKey: StatusType.Complete
            });
        }
    }
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionAcknowledge.js